import blocks from '@/data/blocks.json';

export default {
  blocks: blocks,
}
